export default class UnableToRetrieveDoctorsError extends Error {
	constructor() {
		super("Unable to retrieve doctors.");
		Object.setPrototypeOf(this, new.target.prototype);
	}
}
